import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/Navbar.css";
import { Collapse } from "bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logo from "../assets/images/hi-tech-board-logo.png";
import { Phone, ChevronDown, Menu, X } from "lucide-react";
import recycleIcon from "../assets/images/recycle.png";
import fscIcon from "../assets/images/fsc.png";
import isoIcon from "../assets/images/iso.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  
  // Add these state variables
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownTimeout, setDropdownTimeout] = useState(null);

  // Add these handlers
  const handleMouseEnter = () => {
    if (window.innerWidth >= 992) {
      clearTimeout(dropdownTimeout);
      setDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth >= 992) {
      // Add a 300ms delay before closing
      const timeout = setTimeout(() => {
        setDropdownOpen(false);
      }, 300);
      setDropdownTimeout(timeout);
    }
  };

  const handleDropdownMouseEnter = () => {
    clearTimeout(dropdownTimeout);
  };

  const handleDropdownMouseLeave = () => {
    if (window.innerWidth >= 992) {
      const timeout = setTimeout(() => {
        setDropdownOpen(false);
      }, 200);
      setDropdownTimeout(timeout);
    }
  };

  // Function to handle category click
  const handleCategoryClick = (categoryName) => {
    closeNavbar();
    // Navigate to products page with category state
    navigate('/products', { state: { category: categoryName } });
  };

  // Function to navigate to products page (all products)
  const navigateToAllProducts = () => {
    closeNavbar();
    navigate('/products');
  };

  const closeNavbar = () => {
    const nav = document.getElementById("dustechNav");
    if (nav && nav.classList.contains("show")) {
      const bsCollapse = Collapse.getInstance(nav) || new Collapse(nav, { toggle: false });
      bsCollapse.hide();
    }
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    closeNavbar();
  }, [location]);

  return (
    <header className="dustech-header">
      <nav className={`navbar navbar-expand-lg navbar-dark dustech-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="container-fluid px-4 py-2 px-lg-4">
          {/* LOGO */}
          <Link className="navbar-brand d-flex align-items-center" to="/" onClick={() => window.scrollTo(0, 0)}>
            <div className="logo-container">
              <img
                src={logo}
                alt="Sri Krishna Hi-Tech Paper Board"
                className="brand-logo-img"
              />
            </div>
            <div className="responsive-logo-text ms-2 ms-lg-3">
              <div className="logo-primary">SRI KRISHNA</div>
              <div className="logo-secondary">HI-TECH PAPER BOARD</div>
            </div>
          </Link>

          {/* TOGGLER */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation"
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>

          {/* MENU */}
          <div className={`collapse navbar-collapse ${mobileMenuOpen ? "show" : ""}`} id="dustechNav">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link 
                  className={`nav-link ${location.pathname === "/" ? "active" : ""}`} 
                  to="/"
                  onClick={() => {closeNavbar(); window.scrollTo(0, 0)}}
                >
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link 
                  className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} 
                  to="/about"
                  onClick={() => {closeNavbar(); window.scrollTo(0, 0)}}
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  className={`nav-link ${location.pathname === "/products" ? "active" : ""}`} 
                  to="/products"
                  onClick={() => {closeNavbar(); window.scrollTo(0, 0)}}
                >
                  Products
                </Link>
              </li>

              <li className="nav-item">
                <Link 
                  className={`nav-link ${location.pathname === "/infrastructure" ? "active" : ""}`} 
                  to="/infrastructure"
                  onClick={() => {closeNavbar(); window.scrollTo(0, 0)}}
                >
                  Infrastructure
                </Link>
              </li>

              <li className="nav-item">
                <Link 
                  className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`} 
                  to="/contact"
                  onClick={() => {closeNavbar(); window.scrollTo(0, 0)}}
                >
                  Contact Us
                </Link>
              </li>
            </ul>

            {/* RIGHT SIDE */}
            <div className="navbar-actions d-flex flex-row flex-lg-row align-items-center justify-content-center gap-3 gap-lg-4">
              <div className="contact-info">
                <div className="call-box">
                  <Phone className="call-icon" size={18} />
                  <div>
                    <div className="call-label">24/7 Support</div>
                    <a href="tel:+91 97871 82226" className="call-number">+91 97871 82226</a>
                  </div>
                </div>
              </div>

                   <div className="certification-badges1 ">
              <div className="badge-item1">
                <img src={fscIcon} alt="FSC Certified" className="cert-badge1" />
              </div>
              <div className="badge-item1">
                <img src={isoIcon} alt="ISO Certified" className="cert-badge-iso1" />
              </div>
              </div>

              <Link to="/contact" className="btn btn-primary btn-contact" onClick={() => {closeNavbar(); window.scrollTo(0, 0);}}>
                GET QUOTE
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}